import { Icon } from "@sellar-io/components";

import { BadgeGreen, BadgeAmber } from "../../badge/Badge";

import { formatCurrency } from "@sellar-io/common";

export const getFreeDeliveryBadge = (
  charge: number | undefined,
  iconOnly?: boolean,
) => {
  if (!charge && charge !== 0) {
    return (
      <span className="flex items-center gap-1">
        <BadgeAmber icon="ALERT">Not set</BadgeAmber>
      </span>
    );
  }
  if (charge === 50000) {
    return iconOnly ? (
      <Icon icon="CHECK_CIRCLE" className="text-emerald-700" />
    ) : (
      <span className="flex items-center gap-1">
        <BadgeGreen icon="CHECK_CIRCLE">{formatCurrency(charge)}</BadgeGreen>
      </span>
    );
  }
  return <BadgeAmber icon="ALERT">{formatCurrency(charge)}</BadgeAmber>;
};

export const getFlatChargeBadge = (
  charge: number | null | undefined,
  iconOnly?: boolean,
) => {
  if (!charge) {
    return (
      <span className="flex items-center gap-1">
        <BadgeAmber icon="ALERT">£0.00</BadgeAmber>
      </span>
    );
  }

  if (charge === 3500) {
    return iconOnly ? (
      <Icon icon="CHECK_CIRCLE" className="text-emerald-700" />
    ) : (
      <span className="flex items-center gap-1">
        <BadgeGreen icon="CHECK_CIRCLE">{formatCurrency(charge)}</BadgeGreen>
      </span>
    );
  }
  return <BadgeAmber icon="ALERT">{formatCurrency(charge)}</BadgeAmber>;
};
